import {Inject, Injectable} from '@angular/core';
import {DomainService} from 'common-domain';
import {AuthService, TopLevelDomainVO} from 'common-domain';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {UserRestEndPoints} from './UserRestEndPoints';

@Injectable({
  providedIn: 'root'
})
export class UserDomainService extends DomainService {

  constructor(@Inject(HttpClient) http, @Inject('env') environment, @Inject(AuthService) auth) {
    super(http, environment, auth);
  }

  getUserTLDS(): Observable<any> {
    return this.getListOfDomains(0, 21, '', '');
  }

  getDomain(name: string): Observable<TopLevelDomainVO> {
    return super.getDomain(name);
  }

  createContactsIfNull(domain: TopLevelDomainVO) {
    super.createContactsIfNull(domain);
  }

  getUserNewDelegationTLDS() {
    const url = this.getRestEndPoint() + UserRestEndPoints.GET_LIST_OF_UNDELEGTED_DOMAINS;
    return this.getResponse<any>(url);
  }
}
